import NavBar from '@/components/navigation/NavBar';
import Footer from '@/components/navigation/Footer';
import React from 'react';

export default function Impressum() {
  return (
    <div>
        <NavBar className=" bg-white/100" />
    <div className="container pt-24 mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">Impressum</h1>

      <section className="mb-8">
        <p className="mb-2">Angaben gemäß § 5 TMG:</p>
        <div className="ml-4">
          <p className="font-semibold">Helga Jakobs Immobilienges.mbH</p>
          <p>Uferstr. 40</p>
          <p>52249 Eschweiler</p>
        </div>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-bold mb-2">Vertreten durch:</h2>
        <div className="ml-4">
          <p>Leon Jakobs</p>
        </div>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-bold mb-2">Kontakt:</h2>
        <div className="ml-4 space-y-2">
          <p>
            <span className="font-semibold">Telefon: </span>
            02403-883170
          </p>
          <p>
            <span className="font-semibold">E-Mail: </span>
            <a
              href="mailto:info@jakobs-immobilien.de"
              className="text-blue-600 hover:underline"
            >
              info@jakobs-immobilien.de
            </a>
          </p>
        </div>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-bold mb-2">Registereintrag:</h2>
        <div className="ml-4 space-y-2">
          <p>Eintragung im Handelsregister.</p>
          <p>
            <span className="font-semibold">Registergericht: </span>
            AG Aachen
          </p>
          <p>
            <span className="font-semibold">Registernummer: </span>
            HR B 11468
          </p>
        </div>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-bold mb-2">Aufsichtsbehörde:</h2>
        <div className="ml-4 space-y-2">
          <p>Gewerbeerlaubnis nach 34c GewO erteilt von</p>
          <p className="font-semibold">StädteRegion Aachen</p>
          <p>Zollernstr. 10</p>
          <p>52070 Aachen</p>
        </div>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-bold mb-2">Verbraucherinformationen:</h2>
        <div className="ml-4 space-y-4">
          <p>
            Der Immobilienverband Deutschland IVD e.V. hat eine
            Schlichtungsstelle nach Maßgabe des Verbraucherstreibeilegungsgesetztes
            (VSBG) eingerichtet. Nähere Informationen finden Sie unter:{" "}
            <a
              href="http://www.ombudsmann-immobilien.net"
              target="_blank"
              rel="noreferrer"
              className="text-blue-600 hover:underline"
            >
              ombudsmann-immobilien.net
            </a>
            .
          </p>
          <p>
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbelegung
            (OS) bereit, die Sie hier finden:{" "}
            <a
              href="http://ec.europa.eu/consumers/odr"
              target="_blank"
              rel="noreferrer"
              className="text-blue-600 hover:underline"
            >
              ec.europa.eu/consumers/odr
            </a>
            .
          </p>
        </div>
      </section>
    </div>
    <Footer />
    </div>
  );
}
